/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import ListView from "../../../components/common/ListView";
import {
  useFetchOrderShipmentsData,
  usePickupRequestCreateMutation,
} from "../../../apis/pickupApis";
import { PickupRequestFormData } from "../../../types/types";
import useDebounce from "../../../utilities/useDebounce";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import formatDate from "../../../utilities/helper";
import GeneratePickupRequest from "./GeneratePickupRequest";
import ButtonStyled from "../../../components/common/ButtonStyled";

type Props = {
  open: boolean;
  onClose: () => void;
  refetchRequests: () => void;
};

const PickupRequestModal = ({ open, onClose, refetchRequests }: Props) => {
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const [openShelve, setOpenShelve] = useState<boolean>(false);
  const openShelveToggleModal = () => {
    setOpenShelve(!openShelve);
  };

  const { data: orderShipmentsData, refetch: orderShipmentsRefetch } =
    useFetchOrderShipmentsData(pageNo, 10, searchFor);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const allIds = orderShipmentsData?.orders?.map((item: any) => item.id);
  const isAllSelected = selectedIds?.length === allIds?.length;
  const { mutate, isPending } = usePickupRequestCreateMutation();
  const [generatePickup, setGeneratePickup] = useState(false);
  const {
    register,
    setValue,
    clearErrors,
    formState: { errors },
    watch,
    control,
    handleSubmit,
    reset,
  } = useForm<PickupRequestFormData>();

  const debouncedSearchFor = useDebounce(searchFor, 550);
  useEffect(() => {
    orderShipmentsRefetch(); // Trigger on search or page change
  }, [debouncedSearchFor]);

const handleCheckboxChange = (item: any) => {
  const newSelected = selectedIds.includes(item.id)
    ? selectedIds.filter((i) => i !== item.id)
    : [...selectedIds, item.id];

  setSelectedIds(newSelected);

  // ✅ Send AWB numbers
  const selectedShipments = orderShipmentsData?.orders
    ?.filter((o: any) => newSelected.includes(o.id))
    .map((o: any) => o.awbNumber);

  setValue("shipmentsId", selectedShipments);
};

  const handleSelectAll = () => {
    // setOpenShelve(true);
    setSelectedIds(isAllSelected ? [] : allIds);
    setValue("shipmentsId", isAllSelected ? [] : allIds);
  };

  const handleCreatePickupRequest = (data: any) => {
    // Common success handler
    const handleSuccess = () => {
      openShelveToggleModal();
      reset();

      orderShipmentsRefetch();
      refetchRequests();

      onClose();
    };

    // Common error handler
    const handleError = (error: any) => {
      console.error("Request failed:", error);
      toast.error(error.message || "An error occurred");
    };

    // Prepare request data based on type
    const requestData =
      data.requestType === "PICKUP"
        ? { ...data }
        : {
            shipmentsId: data.shipmentsId,
            requestType: "DROPOFF",
            pickupDate: data.pickupDate,
            timeSlot: data.timeSlot,
          };

    // Execute mutation
    mutate(requestData, {
      onSuccess: handleSuccess,
      onError: handleError,
    });
  };

  if (!open) return null;

  return (
    <>
      <div className="fixed top-0 left-0 w-full h-screen  bg-black/60 z-50 flex items-center justify-end p-4">
        <div className="rounded-2xl w-7/12 relative h-full">
          <div className="flex items-center">
            <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4 w-full rounded-tl-3xl rounded-tr-[63px] ">
              <h1 className="text-2xl">Generate Pickup Request</h1>
            </div>
            <div className="relative ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={38}
                height={37}
                viewBox="0 0 38 37"
                fill="none"
                className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
              >
                <path
                  d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
                  fill="#F7F6F2"
                />
              </svg>

              <button
                onClick={onClose}
                className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
              >
                <IconX size={20} />
              </button>
            </div>
          </div>

          <div className="bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] h-[calc(100vh-10rem)] overflow-y-auto space-y-4 rounded-tr-[30px] p-4  ">
            {!openShelve ? (
              <ListView
                TableClassName="bg-transparent "
                data={orderShipmentsData?.orders ?? []}
                columns={[
                  {
                    label: (
                      <label className="relative flex items-center cursor-pointer">
                        <input
                          className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all bg-white checked:bg-[#FBD037] checked:text-white"
                          type="checkbox"
                          checked={isAllSelected}
                          onChange={handleSelectAll}
                          onClick={(e) => e.stopPropagation()}
                        />
                        <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                          ✓
                        </span>
                      </label>
                    ),
                    render: (item) => (
                      <label className="relative flex items-center cursor-pointer">
                        <input
                          className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all bg-white checked:bg-[#FBD037] checked:text-white"
                          type="checkbox"
                          checked={selectedIds.includes(item.id)}
                          onChange={() => handleCheckboxChange(item)}
                          onClick={(e) => e.stopPropagation()}
                        />
                        <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                          ✓
                        </span>
                      </label>
                    ),
                    className: "w-10",
                  },
                  { label: "#", render: (_, i) => i + 1 },
                  { label: "AWB", render: (c) => c.awbNumber || "" },
                  {
                    label: "Referencer",
                    render: (c: any) => c.referenceNumber || "",
                  },
                  {
                    label: "Forward Through",
                    render: (c) => c.forwardThrough || "",
                  },
                  {
                    label: "City",
                    render: (c) => c.receiverCityName || "",
                  },

                  {
                    label: "Date",
                    render: (c: any) => formatDate(c.createdAt),
                  },

                  // {
                  //   label: "Actions",
                  //   render: (c: any) => (
                  //     <div className="flex justify-center">
                  //       <button className="p-2 border rounded-full bg-[#F7F6F2]">
                  //         <IconEye size={22} />
                  //       </button>
                  //     </div>
                  //   ),
                  // },
                ]}
              />
            ) : (
              <>
                {selectedIds.length && generatePickup && (
                  <GeneratePickupRequest
                    register={register}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    watch={watch}
                    reset={reset}
                    clearErrors={clearErrors}
                  />
                )}
              </>
            )}
          </div>
          <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px] ">
            {selectedIds?.length > 0 && openShelve && generatePickup ? (
              <ButtonStyled
                value="Send Request"
                onClick={handleSubmit(handleCreatePickupRequest)}
                // extraClasses={props.actionButtonExtraClasses}
                // extraProps={props.actionButtonProps}
                // icon={props.actionButtonIcon}
                isPending={isPending}
              />
            ) : (
              <button
                className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-sm font-medium"
                value="Continue"
                onClick={() => {
                  if (selectedIds.length) {
                    setOpenShelve(true);
                    setGeneratePickup(true);
                  }
                }}
              >
                Continue
              </button>
            )}
          </div>
        </div>
      </div>

      {/* <CommonModal
        title={"Generate Pickup Request"}
        open={openShelve}
        onClose={openShelveToggleModal}
        actionButtonText="Generate"
        actionButtonOnClick={handleSubmit(handleCreatePickupRequest)}
      >
        <GeneratePickupRequest
          register={register}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
          reset={reset}
          clearErrors={clearErrors}
        />
      </CommonModal> */}
    </>
  );
};

export default PickupRequestModal;
